/**
 * メンバーページのモーダル
 */

import MicroModal from 'micromodal'

export default class MemberModal {
  constructor(_parm) {
    this.arrayElmsTriggerBtn = [...document.querySelectorAll('[data-member-micromodal-trigger]')];
    if (!this.arrayElmsTriggerBtn.length) return;
    this.attr = {
      thumb: 'data-thumb',
      name: 'data-name',
      caption: 'data-caption',
      content: 'data-content',
    }
    this.elmModalParent = document.querySelector('#js-member-modal');
    this.elmModalModules = {
      thumb: this.elmModalParent.querySelector(`[${this.attr.thumb}]`),
      name: this.elmModalParent.querySelector(`[${this.attr.name}]`),
      caption: this.elmModalParent.querySelector(`[${this.attr.caption}]`),
      content: this.elmModalParent.querySelector(`[${this.attr.content}]`),
    }
  }

  /**
   * メンバー情報をモーダルにセットする
   * @param {Element} _clickBtn クリックしたメンバーのボタン要素
   */
  setMemberValue(_clickBtn) {
    // 値を取得
    const thumb = _clickBtn.querySelector(`[${this.attr.thumb}]`).src;
    const name = _clickBtn.querySelector(`[${this.attr.name}]`).textContent;
    const caption = _clickBtn.querySelector(`[${this.attr.caption}]`)
      ? _clickBtn.querySelector(`[${this.attr.caption}]`).textContent
      : '';
    const content = _clickBtn.querySelector(`[${this.attr.content}]`)
      ? _clickBtn.querySelector(`[${this.attr.content}]`).innerHTML
      : '';
    // 値をセット
    this.elmModalModules.thumb.src = thumb;
    this.elmModalModules.name.textContent = name;
    this.elmModalModules.caption.textContent = caption;
    this.elmModalModules.content.innerHTML = content;
  }

  /**
   * メンバー一覧にクリックイベント付与
   */
  addEventTriggerBtn() {
    this.arrayElmsTriggerBtn.forEach(_elmTriggerBtn => {
      _elmTriggerBtn.addEventListener('click', (_ev) => {
        this.setMemberValue(_elmTriggerBtn);
      });
    });
  }

  init() {
    if (!this.arrayElmsTriggerBtn.length) return;
    this.addEventTriggerBtn();
    MicroModal.init({
      disableScroll: true,
      openTrigger: 'data-member-micromodal-trigger',
    });
  }
}
